<template>
  <div>
    <cangchu-ck />
  </div>
</template>

<script>
// 获取接口地址
import CangchuCk from '@/components/ccManage/ccck/cangchuCk.vue'

export default {
  name: 'Ccck',
  components: {
    // sideMenu,
    // Header,
    CangchuCk
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
